import { createApi } from '@reduxjs/toolkit/query/react';
import { createAuthenticatedBaseQuery, API_BASE_URLS } from '../../../services/shared';

/**
 * Module-owned base RTK Query API for the Verifications backend (one `createApi` per backend,
 * per owning module). Like `agentsApi`, this is intentionally EMPTY of endpoints — features
 * inject the verification reads they need (e.g. the runs feature's run-subject case context)
 * via `agentsVerificationsApi.injectEndpoints` in `features/{x}/data/`.
 *
 * This exists so the agents module does not reach into the legacy `services/VerificationsService`
 * surface: cross-backend reads are owned by the consuming module, expressed in its own contracts.
 */
export const agentsVerificationsApi = createApi({
  reducerPath: 'agentsVerificationsApi',
  baseQuery: createAuthenticatedBaseQuery(API_BASE_URLS.verifications),
  tagTypes: ['Verification', 'EvaWorklist', 'EvaCase', 'EvaCohort', 'EvaActivity'],
  endpoints: () => ({}),
});
